import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-learning-streak',
    imports: [TranslatePipe],
    templateUrl: './learning-streak.component.html',
    styleUrl: './learning-streak.component.scss',
})
export class LearningStreakComponent {
    readonly days = input.required<number>();
}
